<template>
  <van-uploader v-model="fileList" :max-count="1" :before-read="asyncBeforeRead">
    <img :src="imgSrc" :class="imgClassName" mode="aspectFit" />
    <!--                <van-button icon="plus" type="primary">上传文件</van-button>-->
  </van-uploader>
</template>
<script>
import util from '@/assets/js/util'
import { Toast } from 'vant'
import store from '@/store'
import otherImage from '@/assets/images/upload_other.png'

export default {
  name: 'uploadImage',
  props: {
    type: {
      type: String,
      default: 'front'
    },
    access_token: {
      type: String,
      default: ''
    },
    fileType: {
      type: String,
      default: ''
    },
    submitField: {
      type: String,
      default: otherImage
    },
    imgSrc: {
      type: Object,
      default: ''
    },
    imgClassName: {
      type: String,
      default: 'upload-img'
    }
  },
  data() {
    return {
      imgBase64: '',
      fileList: []
    }
  },
  methods: {
    asyncBeforeRead(file) {
      return new Promise(async (resolve, reject) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isJpgOrPng) {
          Toast('请上传 JPG/PNG 格式的图片!', { type: 'fail' })
          reject(false)
          return false
        }
        store.commit('showLoading')

        try {
          const imgBase64 = await util.compressImageToBase64(file, 1920, 1080, 0.5)
          const res =
            this.type === 'bank'
              ? await util.baiduOcrBankImage(imgBase64, this.access_token)
              : this.type === 'other'
              ? true
              : await util.baiduOcrIdCardImage(imgBase64, this.access_token, this.type)
          if (res) {
            const putFileResponse = await this.putBase64ToStore(imgBase64)
            if (putFileResponse) {
              // this.fileList = [{ url: imgBase64 }]
              this.$emit('uploadSuccess', { type: this.type, imgBase64: putFileResponse, data: res, field: this.submitField })
              Toast('上传成功', { type: 'success' })
            }

            resolve(file)
          }
        } catch (e) {
          this.fileList = [{ status: 'failed', message: '上传失败' }]
          reject(false)
          console.log(e)
        } finally {
          store.commit('hideLoading')
        }
      })
    },
    // putFileBase: '/cold-light-core/oss/putFileBase', //上传图片先调
    // uploadPic: '/cold-butler-compose/agtAppMerc/uploadPicToChannel', // 商户进件上传图片
    async putBase64ToStore(imgBase64) {
      // 使用正则表达式匹配 base64 数据
      const match = imgBase64.match(/^data:image\/\w+;base64,(.+)$/)
      let base64Data = ''

      // 如果匹配成功，获取 base64 数据
      if (match && match[1]) {
        base64Data = match[1]
      } else {
        base64Data = imgBase64
      }

      const res = await fetch('/api/cold-light-core/oss/putFileBase', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          fileBase: base64Data
        })
      })
      const response = await res.json()
      const { status } = res
      if (status === 200 && response.code === 200) {
        return response.data
      }
      return false
    },
    async customerPicUpload(filePath) {
      const res = await fetch('/api/cold-butler-compose/agtAppMerc/uploadPicToChannel', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          fileType: this.fileType,
          filePath: filePath // 图片base64
        })
      })
      const response = await res.json()
      const { status } = res
      if (status === 200 && response.code === 200) {
        return response.data
      }
      return false
    }
  }
}
</script>

<style>
.upload-img {
  width: 108px;
  height: 68px;
}
.upload-other-img {
  width: 68px;
  height: 68px;
}
</style>
